import { Progress } from 'antd';
import { downloadHTML, downloadPDF, productDetails, removeMalware, stopDocker } from 'api/api_service';
import { useEffect, useState } from 'react';
import strings from '../../strings/strings.json'
import MalwareFiles from './malware_files';
import MalwareTable from './malware_table';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import { useHistory } from 'react-router-dom'
import axios from 'axios';
import { IProductDetails } from 'types';
import Layout from 'components/layout';

interface Props {
    location: any
}

export default function ScanResult(props: Props) {
    let scan_res = props.location.state[1]
    const guid = props.location.state[0],
        [malwareFile, setMalwareFile] = useState(''),
        [compressedFile, setCompressFile] = useState(''),
        [normalScanResult, setNormalScanReslt] = useState<Array<any>>(Object.keys(scan_res.malware.normal)),
        [compressedFiles, setCompressedScanResult] = useState(scan_res.malware.compressed),
        [productDetail, setProductDetail] = useState<IProductDetails>(),
        [compressedKey, setCompressedKey] = useState(''),
        dispatch = useDispatch(),
        history = useHistory()

    let compressedfileCount: number = 0
    Object.values(scan_res.malware.compressed).map((data: any, index: number) => {
        compressedfileCount += Object.values(data).length
    })
    let malware_files = Object.keys(scan_res.malware.normal).length + compressedfileCount,
        clean_files = scan_res.files_count - malware_files,
        malware_percent = Math.round((malware_files * 100) / scan_res.files_count),
        clean_precent = 100 - malware_percent

    useEffect(() => {
        productDetails()
            .then(res => {
                if (res.status === 200)
                    setProductDetail(res.data.data)
            })
    }, [])

    const allMalwareRemoveHandler = (guid: string) => {
        removeMalware({
            "guid": guid,
            "data": {
            }
        }).then(res => {
            if (res.status === 200 && res.data.success) {
                dispatch(showSnackbar({ "open": true, severity: "success", msg: strings.public_operationDone }));
                /*    let newData = [...normalScanResult]
                   newData.splice(0, normalScanResult.length)
                   setNormalScanReslt(newData)
                   setCompressedScanResult('') */
            } else {
                dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
            }
        })
        .catch(err => {
                    if (err.response.data.error_code === 96) {
                      dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.demo_error }));
                    }  else {
                       dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
                   }              	
        })

    }

    const malwareRemoveHandler = (guid: string) => {

        if (malwareFile || compressedFile) {
            let newData = [...normalScanResult]
            const index = newData.indexOf(malwareFile);
            removeMalware({
                "guid": guid,
                "data": {
                    "path": malwareFile ? malwareFile : compressedKey
                }
            })
                .then(res => {
                    if (res.status === 200 && res.data.success)
                        dispatch(showSnackbar({ "open": true, severity: "success", msg: strings.public_operationDone }));

                    else if (res.data.error_code === 111)
                        dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_fileRemoved }));


                    /* scanResult({ "guid": guid })
                    if (malwareFile && index > -1) {
                        newData.splice(index, 1)
                        setNormalScanReslt(newData)
                        setMalwareFile('')
                    } else {
                        setCompressedScanResult('')
                        setCompressFile('')
                    } */
                })
                .catch(err => {
                    if (err.response.data.error_code === 96) {
                      dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.demo_error }));
                    }  else {
                       dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
                   }              	
               })


        } else {
            dispatch(showSnackbar({ "open": true, severity: "warning", msg: strings.public_chooseFileFirst }));
        }
    }

    const pdfDownloadHandler = () => {
        axios({
            url: `${process.env.REACT_APP_API_SERVER_ADDRESS === undefined ? "" : process.env.REACT_APP_API_SERVER_ADDRESS}/scan/result/export/pdf/${guid}`,
            method: 'post',
            responseType: 'arraybuffer'
        }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ScanReport.pdf');
            document.body.appendChild(link);
            link.click()
        })
    }

    const htmlDownloadHandler = () => {
        downloadHTML({ "guid": guid })
            .then((res: any) => {
                const url = window.URL.createObjectURL(new Blob([res.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', "ScanReport.html")
                document.body.appendChild(link)
                link.click()
            })
    }

    const callbackNormalHandler = (data: any) => {
        setCompressFile('')
        setMalwareFile(data)
    }

    const callbackCompressedHandler = (data: any, key: string) => {
        setMalwareFile('')
        setCompressFile(data)
        setCompressedKey(key)
    }

    return (
        <Layout>
            <div className='w-full h-full'>
                <div dir='rtl' className='grid grid-cols-6'>
                    {/* right side */}
                    <div className={`${(normalScanResult.length !== 0 || Object.values(compressedFiles).length !== 0) ? 'col-span-5' : 'col-span-6'} px-10 mt-10`}>
                        <div className='flex flex-col items-center justify-center'>
                            <div className='flex'>
                                <button className='rounded-2xl flex items-center text-white primary_bg_color py-2 ml-5 px-4 text-xs' onClick={() => history.push('/')}>
                                    <img className='w-5 ml-2' src={require('../../assets/icons/radar.svg').default} alt="Icon" />
                                    <span>{strings.public_rescan}</span>
                                </button>
                                {
                                    (normalScanResult.length !== 0 || (compressedFiles !== undefined && Object.values(compressedFiles).length !== 0)) &&
                                    <button className='rounded-2xl flex items-center text-white bg-red-500 py-2 ml-5 px-4 text-xs' onClick={() => malwareRemoveHandler(guid)}>
                                        <img className='w-5 ml-2' src={require('../../assets/icons/delete.svg').default} alt="Icon" />
                                        <span>{strings.pubic_removeMalware}</span>
                                    </button>
                                }
                                {
                                    (normalScanResult.length !== 0 || (compressedFiles !== undefined && Object.values(compressedFiles).length !== 0)) &&
                                    <button className='rounded-2xl flex items-center text-white bg-red-500 py-2 ml-5 px-4 text-xs' onClick={() => allMalwareRemoveHandler(guid)}>
                                        <img className='w-5 ml-2' src={require('../../assets/icons/delete.svg').default} alt="Icon" />
                                        <span>{strings.pubic_removeAllMalware}</span>
                                    </button>
                                }
                                {
                                    (productDetail !== undefined && productDetail.os === "Linux") &&
                                    <button className='rounded-2xl flex items-center text-white primary_bg_color py-2 ml-5 px-4 text-xs' onClick={() => pdfDownloadHandler()}>
                                        <img className='w-5 ml-2' src={require('../../assets/icons/download_white.svg').default} alt="Icon" />
                                        <span>{strings.scan_PDFDownload}</span>
                                    </button>
                                }
                                <button className='rounded-2xl flex items-center text-white primary_bg_color py-2 ml-5 px-4 text-xs' onClick={() => htmlDownloadHandler()}>
                                    <img className='w-5 ml-2' src={require('../../assets/icons/download_white.svg').default} alt="Icon" />
                                    <span>{strings.scan_HTMLDownload}</span>
                                </button>
                            </div>
                            <span className='VazirEng font-bold text-sm mt-4 select-all'>{guid}</span>
                        </div>
                        <div className='mt-10 border border-gray-200 rounded-lg grid grid-cols-3 py-4'>
                            <div className='col-span-1 flex justify-center'>
                                <div className='flex items-center'>{/* Malware file section */}
                                    <Progress type="circle" percent={malware_percent} width={50} strokeWidth={13} strokeColor='red' showInfo={false} />
                                    <div className='flex flex-col mr-4'>
                                        <span className='primary_text_color font-medium'>{strings.public_malwareFiles}</span>
                                        <span className='text-red-500 font-bold text-lg'>{malware_files}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='border-l border-r border-gray-200 col-span-1 flex justify-center'>
                                <div className='flex items-center'>{/* Clean file section */}
                                    <Progress type="circle" percent={clean_precent} width={50} strokeWidth={13} strokeColor='blue' showInfo={false} />
                                    <div className='flex flex-col mr-4'>
                                        <span className='primary_text_color font-medium'>{strings.public_cleanFiles}</span>
                                        <span className='text-blue-500 font-bold text-lg'>{clean_files}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-span-1 flex justify-center flex-col items-center'>
                                <span className='primary_text_color font-medium'>{strings.public_fileCount}</span>
                                <span className='primary_text_color font-bold text-lg'>{scan_res.files_count}</span>
                            </div>
                        </div>
                        {
                            ((malwareFile && normalScanResult.length !== 0)) &&
                            <MalwareTable data={malwareFile !== undefined && Object.values(scan_res.malware.normal[malwareFile])} scan_result={normalScanResult} />
                        }
                        {
                            (compressedFile !== undefined && compressedFile.length !== 0) &&
                            <MalwareTable data={compressedFile} scan_result={normalScanResult} />
                        }
                    </div>
                    {/* left side */}
                    {
                        (normalScanResult.length !== 0 || compressedFiles.length !== 0) &&
                        <div className='col-span-1 h-full overflow-auto'>
                            <MalwareFiles
                                compressed_data={compressedFiles}
                                malware_data={normalScanResult}
                                normalCallback={(data) => callbackNormalHandler(data)}
                                compressedCallback={(data, key) => callbackCompressedHandler(data, key)}
                                malwareFile={malwareFile !== undefined && malwareFile}
                            />
                        </div>
                    }
                </div>
            </div>
        </Layout>
    )
}
